import * as actionType from "./action";

export function aboutMicroservicesReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_ABOUT_MICROSERVICES_SUCCESS:
      return {
        ...state,
        response,
      };
    case actionType.GET_ABOUT_MICROSERVICES_ERROR:
      return {
        ...state,
        response,
      };
    default:
      return state;
  }
}

export function aboutMicroserviceReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_ABOUT_MICROSERVICE_SUCCESS:
      return {
        ...state,
        response,
      };
    case actionType.GET_ABOUT_MICROSERVICE_ERROR:
      return {
        ...state,
        response,
      };
    default:
      return state;
  }
}

export function aboutMicroserviceOpReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.ADD_ABOUT_MICROSERVICE_SUCCESS:
      return {
        ...state,
        response,
      };
    case actionType.ADD_ABOUT_MICROSERVICE_ERROR:
      return {
        ...state,
        response,
      };
    case actionType.MODIFY_ABOUT_MICROSERVICE_SUCCESS:
      return {
        ...state,
        response,
      };
    case actionType.MODIFY_ABOUT_MICROSERVICE_ERROR:
      return {
        ...state,
        response,
      };
    case actionType.DELETE_ABOUT_MICROSERVICE_SUCCESS:
      return {
        ...state,
        response,
      };
    case actionType.DELETE_ABOUT_MICROSERVICE_ERROR:
      return {
        ...state,
        response,
      };
    default:
      return state;
  }
}
